import React from 'react';
import type ServicedeskCmdbAssetsCustomMetrics from '@atlassian/jira-spa-apps-servicedesk-cmdb-assets-custom-metrics/src/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyServicedeskCmdbAssetsAnalyticsDataViewList = lazyForPaint<
	typeof ServicedeskCmdbAssetsCustomMetrics
>(
	() =>
		import(
			/* webpackChunkName: "async-servicedesk-cmdb-assets-analytics-data-view-list", jiraSpaEntry: "async-servicedesk-assets-analytics-data-view-list" */ '@atlassian/jira-spa-apps-servicedesk-cmdb-assets-custom-metrics'
		).then((exportedMembers) => exportedMembers.CmdbAssetsAnalyticsDataViewList),
	{ ssr: false },
);

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyServicedeskCmdbAssetsAnalyticsDataViewCreate = lazyForPaint<
	typeof ServicedeskCmdbAssetsCustomMetrics
>(
	() =>
		import(
			/* webpackChunkName: "async-servicedesk-cmdb-assets-analytics-data-view-create", jiraSpaEntry: "async-servicedesk-assets-analytics-data-view-create" */ '@atlassian/jira-spa-apps-servicedesk-cmdb-assets-custom-metrics'
		).then((exportedMembers) => exportedMembers.CmdbAssetsAnalyticsDataViewCreate),
	{ ssr: false },
);

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyServicedeskCmdbAssetsAnalyticsDataViewDetails = lazyForPaint<
	typeof ServicedeskCmdbAssetsCustomMetrics
>(
	() =>
		import(
			/* webpackChunkName: "async-servicedesk-cmdb-assets-analytics-data-view-details", jiraSpaEntry: "async-servicedesk-assets-analytics-data-view-details" */ '@atlassian/jira-spa-apps-servicedesk-cmdb-assets-custom-metrics'
		).then((exportedMembers) => exportedMembers.CmdbAssetsAnalyticsDataViewDetails),
	{ ssr: false },
);

export const AssetsAnalyticsDataViewList = () => (
	<LazyPage
		Page={LazyServicedeskCmdbAssetsAnalyticsDataViewList}
		pageId="spa-apps/servicedesk/insight/cmdb-assets-analytics-data-view-list"
		shouldShowSpinner
	/>
);

export const AssetsAnalyticsDataViewCreate = () => {
	return (
		<LazyPage
			Page={LazyServicedeskCmdbAssetsAnalyticsDataViewCreate}
			pageId="spa-apps/servicedesk/insight/cmdb-assets-analytics-data-view-create"
			shouldShowSpinner
		/>
	);
};

export const AssetsAnalyticsDataViewDetails = () => (
	<LazyPage
		Page={LazyServicedeskCmdbAssetsAnalyticsDataViewDetails}
		pageId="spa-apps/servicedesk/insight/cmdb-assets-analytics-data-view-details"
		shouldShowSpinner
	/>
);
